// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bhd2P{flex:1;min-height:0;overflow:hidden;position:relative}.Q4B5l{position:absolute;top:0;left:0;right:0;z-index:10}.TDH4K{position:absolute;top:64px;left:0;right:0;padding:8px;z-index:10}.qS9Oc{flex:1;display:flex;flex-direction:column;overflow:hidden;min-height:0}.yeG7n{padding-top:64px;padding-bottom:72px}.SkRIg{padding-top:64px;padding-bottom:16px}.bpIxD{position:absolute;bottom:0;left:0;right:0;z-index:10}.Oq4m5{position:absolute;top:12px;right:8px;width:200px;max-height:calc(100% - 24px);overflow-y:auto;z-index:15}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentBox": `bhd2P`,
	"headerWrapper": `Q4B5l`,
	"titleWrapper": `TDH4K`,
	"contentArea": `qS9Oc`,
	"contentAreaOnboarding": `yeG7n`,
	"contentAreaNoFooter": `SkRIg`,
	"footerWrapper": `bpIxD`,
	"setupBrandContainer": `Oq4m5`
};
export default ___CSS_LOADER_EXPORT___;
